<template>
  <div class="customer-page">
    <h2>Danh sách khách hàng</h2>

    <!-- FILTER -->
    <div class="row mb-3 g-2">
      <div class="col-xl-3 col-lg-4 col-md-6">
        <label class="font-weight-bold">Trạng thái KH</label>
        <b-form-select v-model="filter.status" :options="statusOptions" />
      </div>

      <div class="col-xl-3 col-lg-4 col-md-6">
        <label class="font-weight-bold">Trạng thái task</label>
        <b-form-select v-model="filter.taskStatus" :options="taskStatusOptions" />
      </div>

      <!-- <div class="col-xl-3 col-lg-4 col-md-6">
        <label class="font-weight-bold">Nhân viên sale [ID]</label>
        <input
          class="form-control"
          v-model="filter.sale"
          placeholder="Nhập Id sale"
          :disabled="filter.taskStatus === 'none'"
        />
      </div> -->

      <div class="col-xl-3 col-lg-4 col-md-6">
        <label class="font-weight-bold">Từ ngày</label>
        <input type="date" class="form-control" v-model="filter.fromDate" />
      </div>

      <div class="col-xl-3 col-lg-4 col-md-6">
        <label class="font-weight-bold">Đến ngày</label>
        <input type="date" class="form-control" v-model="filter.toDate" />
      </div>

      <!-- BUTTON -->
      <div class="col-12 d-flex flex-wrap gap-2 mt-4">
        <b-button variant="primary" @click="searchCustomer">
          Tìm kiếm
        </b-button>

        <b-button variant="outline-success" @click="resetFilter">
          <i class="fa fa-refresh mr-1"></i> Đặt lại
        </b-button>

      </div>
    </div>

    <!-- TABLE -->
    <div class="table-scroll">
      <b-table class="customer-table" v-if="customers.length" bordered hover head-variant="dark" responsive
        :items="customers" :fields="fields">
        <template #cell(stt)="data">
          {{ (currentPage - 1) * perPage + data.index + 1 }}
        </template>

        <template #cell(status)="data">
          <span :class="statusClass(data.item.status)">
            {{ statusText(data.item.status) }}
          </span>
        </template>

        <template #cell(last_zns_sent_at)="data">
        {{ formatDate(data.item.last_zns_sent_at) }}
      </template>

        <template #cell(actions)="data">
        <!-- <b-button
        size="sm"
        variant="link"
        class="icon-btn text-info"
        title="Xem chi tiết"
        @click="goToDetail(data.item)"
      >
        <i class="fa fa-eye"></i>
      </b-button> -->

          <b-button size="sm" variant="link" class="icon-btn text-info" title="Gửi ZNS" @click="actionZns(data.item)">
            <i class="fa fa-paper-plane"></i>
          </b-button>
        </template>
      </b-table>
      <div v-else class="text-center mt-3 text-muted">
        Không có dữ liệu
      </div>
    </div>

    <!-- PAGINATION -->
    <div class="d-flex justify-content-between mt-3 flex-wrap">
      <small class="text-muted">
        Hiển thị
        {{ (currentPage - 1) * perPage + 1 }}
        –
        {{ Math.min(currentPage * perPage, total) }}
        /
        {{ total }}
        bản ghi
      </small>

      <div class="d-flex">
        <b-form-select size="sm" v-model="selectedPerPage" :options="optionsPages" class="mr-2" style="max-width:100px"
          @change="changePerPage" />
        <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" size="sm" @change="changePage" />
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios'

export default {
  data() {
    return {
      filter: {
        status: -1,
        taskStatus: '',
        sale: '',
        fromDate: null,
        toDate: null
      },

      fields: [
        { key: 'stt', label: 'STT' },
        { key: 'full_name', label: 'Tên khách hàng' },
        { key: 'phone_number', label: 'SĐT' },
        { key: 'address', label: 'Địa chỉ' },
        { key: 'sale_name', label: 'Nhân viên sale' },
        { key: 'status', label: 'Trạng thái KH' },
        { key: 'dateCalling', label: 'Ngày gọi' },
        { key: 'timeCalling', label: 'Giờ gọi' },
        { key: 'last_zns_status', label: 'ZNS' },
        { key: 'last_zns_sent_at', label: 'Lần gửi ZNS' },
        { key: 'actions', label: 'Quản lý', }
      ],

      customers: [],
      total: 0,
      currentPage: 1,
      perPage: 20,
      selectedPerPage: 20,

      optionsPages: [
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' }
      ],

      statusOptions: [
        { value: -1, text: 'Tất cả' },
        { value: 0, text: 'Chưa xử lý' },
        { value: 1, text: 'Đồng ý' },
        { value: 2, text: 'Từ chối' },
        { value: 3, text: 'Không nghe máy' },
        { value: 4, text: 'Không bắt máy' },
        { value: 5, text: 'Cần tư vấn thêm' }
      ],

      taskStatusOptions: [
        { value: '', text: 'Tất cả' },
        { value: 'none', text: 'Chưa giao task' },
        { value: 'pending', text: 'Chưa làm' },
        { value: 'completed', text: 'Đã làm' }
      ]
    }
  },

  mounted() {
    this.fetchCustomers()
  },

  methods: {
    searchCustomer() {
      this.currentPage = 1
      this.fetchCustomers()
    },

    resetFilter() {
      this.filter = {
        status: -1,
        taskStatus: '',
        sale: '',
        fromDate: null,
        toDate: null
      }
      this.currentPage = 1
      this.perPage = 20
      this.selectedPerPage = 20
      this.fetchCustomers()
    },

    changePage(page) {
      this.currentPage = page
      this.fetchCustomers()
    },

    changePerPage() {
      this.currentPage = 1
      this.perPage = this.selectedPerPage
      this.fetchCustomers()
    },

    async fetchCustomers() {
      const res = await apiClient.get('/api/v1/admin/customer/list', {
        params: {
          status: this.filter.status,
          taskStatus: this.filter.taskStatus || undefined,
          sale: this.filter.sale || undefined,
          fromDate: this.filter.fromDate || undefined,
          toDate: this.filter.toDate || undefined,
          perPage: this.perPage,
          currentPage: this.currentPage
        }
      })

      if (res && res.data) {
        this.customers = res.data.items || []
        this.total = Number(res.data.total || 0)
      }
    },

    async importCustomerExcel(event) {
      const file = event.target.files[0]
      if (!file) return

      const formData = new FormData()
      formData.append('file', file)

      try {
        await apiClient.post(
          '/api/v1/admin/upload',
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )

        this.$bvToast?.toast('Import thành công', {
          variant: 'success',
          solid: true
        })

        this.fetchCustomers()
      } catch (e) {
        this.$bvToast?.toast('Import thất bại', {
          variant: 'danger',
          solid: true
        })
      }
      event.target.value = ''
    },


    statusText(status) {
      return {
        0: 'Chưa xử lý',
        1: 'Đồng ý',
        2: 'Từ chối',
        3: 'Không nghe máy',
        4: 'Không bắt máy',
        5: 'Cần tư vấn thêm'
      }[status]
    },

    statusClass(status) {
      return {
        1: 'text-success font-weight-bold',
        2: 'text-danger',
        3: 'text-warning',
        4: 'text-secondary',
        5: 'text-info'
      }[status]
    },
    goToDetail(item) {
      this.$router.push(`/admin/customer/${item.id}`)
    },
    goToDetail(item) {
      this.$router.push(`/admin/customer/${item.id}`)
    },

    async actionZns(item) {
      try {

        const res = await apiClient.post(
          "/api/v1/admin/customer/zns/send",
          { customerId: item.id }
        )
        if (res.data.success) {
          this.$bvToast.toast(res.data.message || 'Gửi ZNS thành công!', {
            title: 'Thành công',
            toaster: 'b-toaster-top-right',
            variant: 'success',
            solid: true
          })
        } else {
          this.$bvToast.toast(res.data.message || "Gửi ZNS thất bại!", {
            title: 'Thất bại',
            toaster: 'b-toaster-top-right',
            variant: "danger",
            solid: true
          })
        }
      } catch (err) {
        console.error(err)

        this.$bvToast.toast("API lỗi", {
          variant: "danger",
          solid: true
        })
      }
    },
    formatDate(date) {
      if (!date) return '-'

      const d = new Date(date)

      return d.toLocaleDateString('vi-VN')
    },
  }
}
</script>

<style scoped>
.label-page {
  line-height: 34px;
}

.table-scroll {
  overflow-x: auto;
}

.customer-table {
  min-width: 1200px;
}
</style>
